import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import BooleanCheckbox from '../../boolean/BooleanCheckbox';

export const describeOverrides = (flags) => flags.map(({ defaultValue, summary }) => summary[Boolean(defaultValue)]).join(' ');

const ScaleReadingOverrides = ({ props: { label, disabled, flags = [] } }) => {
    const { control, setValue } = useFormContext();

    useEffect(() => {
        if (!disabled) return;
        flags.forEach(({ name, defaultValue }) => setValue(name, defaultValue));
    }, [disabled]);

    if (!disabled) {
        return (
            <Grid container spacing={1}>
                {flags.map(({ name, label: flagLabel, defaultValue }) => (
                    <Grid item xs={12} sm={6} key={name}>
                        <BooleanCheckbox name={name} props={{ label: flagLabel, defaultValue }} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <>
            {flags.map(({ name, defaultValue }) => (
                <Controller key={name} name={name} control={control} defaultValue={defaultValue} render={() => null} />
            ))}
            <Typography variant="body2" color="textSecondary">
                {label ? `${label}: ` : ''}
                {describeOverrides(flags)}
            </Typography>
        </>
    );
};

export default ScaleReadingOverrides;
